export const parseNumber = (value: string) => {
  return Number(value.replace(/\D/g, ""));
};

type FullFormatNumberPropsType = {
  value: number | string;
  decimalCount?: number;
  shortenValue?: number;
  noFormatNumber?: boolean;
  round?: number;
};

type FullFormatPropsType = (props: FullFormatNumberPropsType) => string;

export const fullFormatNumbers: FullFormatPropsType = ({
  value,
  decimalCount = 0,
  shortenValue,
  noFormatNumber = false,
  round = 0,
}: FullFormatNumberPropsType) => {
  const numValue = Number(value);
  const k = 1e3;
  const m = 1e6;
  const b = 1e9;

  if (shortenValue && numValue >= shortenValue) {
    if (numValue >= b) {
      return (numValue / b).toFixed(decimalCount) + "B";
    } else if (numValue >= m) {
      return (numValue / m).toFixed(decimalCount) + "M";
    } else if (numValue >= k) {
      return (numValue / k).toFixed(decimalCount) + "K";
    }
  }
  if (noFormatNumber) {
    return value.toString();
  }
  if (round) {
    const factor = Math.pow(10, round);
    return (Math.round(numValue * factor) / factor).toString();
  }

  return numValue
    .toFixed(decimalCount)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
